import { Routes } from "@angular/router";
import { LayoutComponent } from "app/shared/components/layout/layout.component";
import { MsalGuard } from '@azure/msal-angular';
import { CompanyListComponent } from "./component/company-list/company-list.component";
import { AddCompanyComponent } from "./component/add-company/add-company.component";
import { CompanyDetailsComponent } from "./component/company-details/company-details.component";
import { CompanyAuditListComponent } from "./component/company-audit-list/company-audit-list.component";
import { AddCompanyAuditComponent } from "./component/add-company-audit/add-company-audit.component";
import { CompanyAuditDetailsComponent } from "./component/company-audit-details/company-audit-details.component";
import { CompanyUsersComponent } from "./component/company-users/company-users.component";
import { CompanyAuditListTabComponent } from "./component/company-audit-list-tab/company-audit-list-tab.component";
import { CompanyAuditTemplateComponent } from "./component/company-audit-template/company-audit-template.component";
import { AdminGuard } from "../shared/services/admin-guard.service";
import { CompanyLendersComponent } from "./component/company-lenders/company-lenders.component";
import { AuditTargetsComponent } from "./component/audit-targets/audit-targets.component";

export const COMPANY_ROUTES: Routes = [
	{
		path: 'company',
		component: LayoutComponent,
		canActivate: [MsalGuard],
		children: [
            { path: '', component: CompanyListComponent },
            { path: 'add', component: AddCompanyComponent },
            { path: ':id', component: CompanyDetailsComponent },
            { path: 'audits/:id', component: CompanyAuditListTabComponent },
            { path: 'audits/add/:id', component: AddCompanyAuditComponent },
            { path: 'audits/:companyId/:auditId', component: CompanyAuditDetailsComponent },
            { path: 'users/:companyId', component: CompanyUsersComponent },
            { path: 'audit-templates/:id', component: CompanyAuditTemplateComponent },
            { path: 'lenders/:id', component: CompanyLendersComponent },
            { path: 'audit-targets/:id', component: AuditTargetsComponent }
		]
	}
];
